const mapPickupPointToApplePayShippingContact = (pickupPoint)=>{
    const addressLines = [];
    if (pickupPoint.streetName) {
        addressLines.push(pickupPoint.streetName);
    }
    if (pickupPoint.streetNumber) {
        addressLines.push(pickupPoint.streetNumber);
    }
    return {
        addressLines,
        postalCode: pickupPoint.postalCode || '',
        locality: pickupPoint.town || '',
        countryCode: pickupPoint.country
    };
};

export { mapPickupPointToApplePayShippingContact };
//# sourceMappingURL=pickup-point-to-apple-shipping-contact.js.map
